webpackJsonp([192551386620669],{

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-gap: ', 'px;\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: grid;\n  grid-gap: ', 'px;\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 16rem;\n'], ['\n  max-width: 16rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Container.extend(_templateObject, function (props) {
	  return props.theme.space[3];
	});
	
	var Sponsor = _designSystem.Box.withComponent('img').extend(_templateObject2);
	
	var Sponsors = function Sponsors(props) {
	  return _react2.default.createElement(
	    Base,
	    _extends({ maxWidth: 48 }, props),
	    _react2.default.createElement(Sponsor, { alt: 'Mike\u2019s Video', src: '/sponsors/mikes.png' }),
	    _react2.default.createElement(Sponsor, { alt: 'Minitab', src: '/sponsors/minitab.png' }),
	    _react2.default.createElement(Sponsor, { alt: 'Sketch', src: '/sponsors/sketch.png' }),
	    _react2.default.createElement(Sponsor, { alt: 'Ben Franklin', src: '/sponsors/ben-franklin.jpg' }),
	    _react2.default.createElement(Sponsor, { alt: 'Balsamiq', src: '/sponsors/balsamiq.png' })
	  );
	};
	
	exports.default = Sponsors;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(4);
	
	var _Nav = __webpack_require__(48);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Sponsors = __webpack_require__(82);
	
	var _Sponsors2 = _interopRequireDefault(_Sponsors);
	
	var _Footer = __webpack_require__(47);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Nav2.default, null),
	    _react2.default.createElement(
	      _designSystem.Box.header,
	      { bg: 'alt', pt: 6, pb: [5, 6] },
	      _react2.default.createElement(
	        _designSystem.Container,
	        { maxWidth: 48, color: 'white', px: 3 },
	        _react2.default.createElement(
	          _designSystem.Heading.h1,
	          { f: [6, 7], mb: 2 },
	          'Sponsorship'
	        ),
	        _react2.default.createElement(
	          _designSystem.Heading.h2,
	          { f: [3, 4] },
	          'We\u2019re trying to bring technology to the forefront of Central PA, and your help is crucial.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _designSystem.Container,
	      { py: [4, 5] },
	      _react2.default.createElement(
	        _designSystem.Heading.h2,
	        { color: 'primary', f: 4, mb: 3, align: 'center', caps: true },
	        'Our sponsors'
	      ),
	      _react2.default.createElement(_Sponsors2.default, null)
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sponsors-js-3b8bd5882d2f63ea4e7d.js